import { n as pathToRegexp, t as match } from "./pathToRegexp-7eww5BY6.mjs";

export { match, pathToRegexp };